import React from 'react';
import Box from '../../Box/Box.js';
import { defaultSxProp } from '../../utils/defaultSxProp.js';
import { includesSystemProps } from '../../utils/includeSystemProps.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Utility to toggle rendering a Box component that receives sx props
 * or a "plain" component based on the provided `as` prop. Other props will be passed through to an element or component created with the `as` prop.
 *
 * @param sx - the sx prop to check against the default sx prop
 * @param defaultAs - the default component to use when `as` is not provided
 */
function toggleSxComponent(
// eslint-disable-next-line @typescript-eslint/no-explicit-any
defaultAs) {
  const Wrapper = /*#__PURE__*/React.forwardRef(function Wrapper({
    as: BaseComponent = defaultAs,
    sx: sxProp = defaultSxProp,
    ...rest
  }, ref) {
    if (sxProp !== defaultSxProp || includesSystemProps(rest)) {
      return /*#__PURE__*/React.createElement(Box, _extends({
        as: BaseComponent
      }, rest, {
        sx: sxProp,
        ref: ref
      }));
    }
    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, rest, {
      ref: ref
    }));
  });
  return Wrapper;
}

export { toggleSxComponent };
